import React from 'react';
import { Link } from 'react-router-dom';
import { Navbar, Img } from './styles';

const NavbarHeader = () => (
  <Navbar>
    <Link className="Navbar__brand" to="/">
      <Img src="https://storage.googleapis.com/lucia-static/media/img/auteco-logo.png" alt="Logo" />
    </Link>
  </Navbar>
)

export default NavbarHeader;
